import { Injectable, signal } from '@angular/core';

// Shared sidebar UI state (mobile drawer), split from the old SidebarPortalService; page-header toggles it, both chrome components read it.
@Injectable({ providedIn: 'root' })
export class SidebarUiService {
  // Controls the mobile slide-in drawer state (new: is-open, legacy: is-shown).
  readonly mobileOpen = signal(false);

  toggleMobile(): void {
    this.mobileOpen.update((v) => !v);
  }

  closeMobile(): void {
    this.mobileOpen.set(false);
  }
}
